import React, { memo, useMemo } from "react";
import { Container } from "@pixi/react";
import { Settings, GAME_LAYOUT } from "../../../settings";
import OverlayReel from "../OverlayReel/OverlayReel";
import { useReelRefs } from "../../../Contexts/ReelRefsContext";
import { useSelector } from "react-redux";
import { selectHoldAndWinActive, selectFreeSpinActive } from "../../../State/selectors";

const OverlayReelSet = memo(({ symbolWidth, symbolHeight, reelSpacing }) => {
  const { overlayReelRefs } = useReelRefs();
  const holdAndWinActive = useSelector(selectHoldAndWinActive);
  const freeSpinActive = useSelector(selectFreeSpinActive);

  // Memoize container Y position calculation
  const containerY = useMemo(
    () => -symbolHeight * (0.5 * Settings.SYMBOLS_VISIBLE - 0.5),
    [symbolHeight]
  );

  // Memoize alpha value
  const containerAlpha = useMemo(
    () => (holdAndWinActive || freeSpinActive ? 0.001 : 1),
    [holdAndWinActive, freeSpinActive]
  );

  return (
    <Container
      name="spine_overlay"
      zIndex={5}
      y={containerY}
      alpha={containerAlpha}
    >
      {GAME_LAYOUT.REEL_INDICES.map((index) => (
        <OverlayReel
          key={index}
          symbolHeight={symbolHeight}
          symbolWidth={symbolWidth}
          reelSpacing={reelSpacing}
          overlaySymbols={GAME_LAYOUT.SYMBOL_INDICES}
          ref={(el) => {
            overlayReelRefs.current[index] = el;
          }}
          index={index}
        />
      ))}
    </Container>
  );
});

export default OverlayReelSet;
